// extracted by mini-css-extract-plugin
export default {"cls1":"VeloNotification-NotificationText_cls1__RHCBe","cls2":"VeloNotification-NotificationText_cls2__yxlZi VeloNotification-NotificationText_cls1__RHCBe"};